import React from "react";
import { type GetStaticProps, type GetStaticPaths } from "next";
import { PostNoIndex, checkPosthasEsperienzecategories } from "~/lib/db/post";
import { default as PostPage } from "../a/[slug]";
import { extractFirstBlock } from "~/utils/extractBlocksData";
import { getLastArticle } from "~/lib/db/posts";
import { getPostInfoBySlug } from "~/lib/buildPost";
import { type ArticleReturnType } from "~/lib/db/types";
import { type Poll } from "~/lib/db/poll";
import { getPollsFromContent } from "~/lib/polls";

const PostPublicPage = ({
  post,
  noIndex,
  hiddenDescription,
  polls,
}: {
  post: ArticleReturnType;
  noIndex: string;
  hiddenDescription: boolean;
  polls: Poll[];
}) => (
  <PostPage
    post={post}
    restrictAccess={!post?.meta?._no_login_field}
    noIndex={noIndex}
    hiddenDescription={hiddenDescription}
    polls={polls}
  />
);

export default PostPublicPage;

export const getStaticPaths: GetStaticPaths = async () => {
  const articleByCategory = await getLastArticle();
  return {
    paths: articleByCategory.map((article) => ({
      params: { slug: article.post_name },
    })), //indicates that no page needs be created at build time
    fallback: true, //indicates the type of fallback
  };
};

export const getStaticProps: GetStaticProps<{
  post: ArticleReturnType;
}> = async ({ params }) => {
  if (!params) return { notFound: true };

  try {
    const postInfo = await getPostInfoBySlug(params.slug as string);

    if (!postInfo) return { notFound: true };
    const noIndex = await PostNoIndex(
      params.slug as string,
      postInfo?.meta?.rank_math_robots as string
    );
    if (!postInfo?.meta?._no_login_field) {
      postInfo.post_content = extractFirstBlock(postInfo.post_content);
    }
    const hiddenDescription = await checkPosthasEsperienzecategories(
      params.slug as string
    );
    const polls = await getPollsFromContent(postInfo.post_content);

    return {
      props: {
        post: postInfo,
        noIndex,
        hiddenDescription,
        polls: polls != null ? polls : [],
      },
    };
  } catch (error) {
    console.log("Error fetching static props for", params.slug, error);
    return { notFound: true };
  }
};
